<template>
  <AppLayout>
    <HeadlessBid
      :key="`listing-${route.params.slug}`"
      :listing-slug="route.params.slug"
      :bid-id="route.params.bid"
    >
      <template #fallback="{ register, loginURI }">
        <div class="mx-auto max-w-md pt-8">
          <div class="rounded-xl border border-boba-grey/50 bg-boba-sand-light shadow-sm px-5 py-5 md:px-8 md:py-6">
            <h1 class="text-xl font-semibold tracking-tight text-boba-brown">Bid history</h1>
            <sign-in-prompt
              class="mt-3"
              :login-u-r-i="loginURI"
              message="Sign in to see your bids on this auction."
              @register="register"
            />
          </div>
        </div>
      </template>

      <template #default="{ listing, bids, onCancelBid, cancelling, cancelError }">
        <div class="mx-auto max-w-7xl pt-2 md:pt-8 md:grid md:grid-cols-12 md:items-start md:gap-x-8 lg:gap-x-12">
          <div class="md:col-span-5 md:sticky md:top-8">
            <router-link
              :to="{ name: 'listing', params: { slug: listing.slug } }"
              class="block rounded-xl border border-boba-grey/50 bg-white p-3 shadow-sm aspect-[4/3] overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-boba-brown focus-visible:ring-offset-2"
            >
              <img
                :src="listing.images[0]"
                :alt="`${listing.title} product image`"
                class="h-full w-full object-contain rounded-lg"
              />
            </router-link>

            <div class="mt-4 flex flex-wrap items-center justify-between gap-3">
              <router-link
                :to="{ name: 'account-home' }"
                class="inline-flex items-center gap-2 min-h-[44px] text-sm font-medium text-boba-grey-dark hover:text-boba-brown focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-boba-brown rounded"
              >
                <arrow-uturn-left-icon class="h-4 w-4" aria-hidden="true" />
                <span>All auctions</span>
              </router-link>
              <router-link
                :to="{ name: 'listing', params: { slug: listing.slug } }"
                class="inline-flex items-center justify-center h-11 rounded-lg bg-boba-brown px-5 text-sm font-semibold text-white hover:bg-boba-brown/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-boba-brown focus-visible:ring-offset-2"
              >
                View auction
              </router-link>
            </div>
          </div>

          <div class="mt-5 md:mt-0 md:col-span-7 min-w-0">
            <div>
              <p
                v-if="listing.subtitle"
                class="text-xs md:text-sm font-semibold uppercase tracking-[0.12em] text-boba-grey-dark"
              >
                {{ listing.subtitle }}
              </p>
              <h1 class="mt-1 text-3xl md:text-4xl font-semibold tracking-tight leading-tight text-boba-brown text-balance">
                {{ listing.title }}
              </h1>
            </div>

            <auction-results
              v-if="listing.isLowBid() && listing.hasEnded()"
              class="mt-6 md:mt-7"
              :listing="listing"
              :bids="bids"
            />
            <bid-history
              v-else
              class="mt-6 md:mt-7"
              :listing="listing"
              :bids="bids"
              :cancelling="cancelling"
              :error="cancelError"
              @cancel="onCancelBid"
            />
          </div>
        </div>
      </template>
    </HeadlessBid>
  </AppLayout>
</template>
<script lang="ts" setup>
import AppLayout from "@/components/Layouts/Application.vue";
import HeadlessBid from "@/components/Headless/Bid.vue";
import AuctionResults from "@/components/Listing/AuctionResults.vue";
import BidHistory from "@/components/Account/BidHistory.vue";
import SignInPrompt from "@/components/Listing/SignInPrompt.vue";
import { useRoute } from "vue-router";
import { ArrowUturnLeftIcon } from "@heroicons/vue/24/outline";

const route = useRoute();
</script>
